import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import i18n from '@/shared/i18n';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

function getRtf() {
  return new Intl.RelativeTimeFormat(i18n.language, { numeric: 'auto' });
}

export function formatRelativeTime(dateString: string): string {
  const now = Date.now();
  const then = new Date(dateString).getTime();
  const diffMs = then - now;
  const absDiffSec = Math.abs(diffMs) / 1000;

  if (absDiffSec < 60) return i18n.t('common:time.justNow');

  const rtf = getRtf();

  const minutes = Math.round(diffMs / 60_000);
  if (Math.abs(minutes) < 60) return rtf.format(minutes, 'minute');

  const hours = Math.round(diffMs / 3_600_000);
  if (Math.abs(hours) < 24) return rtf.format(hours, 'hour');

  const days = Math.round(diffMs / 86_400_000);
  if (Math.abs(days) < 30) return rtf.format(days, 'day');

  const months = Math.round(diffMs / 2_592_000_000);
  if (Math.abs(months) < 12) return rtf.format(months, 'month');

  const years = Math.round(diffMs / 31_536_000_000);
  return rtf.format(years, 'year');
}

export function getDateLocale(): string {
  return i18n.language === 'ko' ? 'ko-KR' : 'en-US';
}
